<template>
  <div>
    <!-- <DeviceShowcase /> -->
    <HeroSection />
    <SocialProof />
    <ImageGrid />
    <FeaturesGrid />
    <HowItWorks />
    <Testimonials />
    <CtaBanner />
    <StatsBanner />
    <PricingSection />
    <FooterSection />
  </div>
</template>

<script>
import HeroSection from "../components/HeroSection.vue";
import SocialProof from "../components/SocialProof.vue";
import DeviceShowcase from "../components/DeviceShowcase.vue";
import ImageGrid from "../components/ImageGrid.vue";
import FeaturesGrid from "../components/FeaturesGrid.vue";
import HowItWorks from "../components/HowItWorks.vue";
import Testimonials from "../components/Testimonials.vue";
import CtaBanner from "../components/CtaBanner.vue";
import StatsBanner from "../components/StatsBanner.vue";
import PricingSection from "../components/PricingSection.vue";
import FooterSection from "../components/FooterSection.vue";

export default {
  name: "HomePage",
  components: {
    HeroSection,
    SocialProof,
    DeviceShowcase,
    ImageGrid,
    FeaturesGrid,
    HowItWorks,
    Testimonials,
    CtaBanner,
    StatsBanner,
    PricingSection,
    FooterSection,
  },
};
</script>
